<template>
  <Teleport to="body">
    <div ref="slideContent" v-if="visible" class="modal-overlay" role="dialog" aria-modal="true" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-body">
          <div v-if="isotope" class="isotope-details flex flex-column gap-2">
            <div class="flex gap-5">
              <div class="isotope-symbol">
                {{ isotope.symbol }}
              </div>
              <div class="isotope-header">
                <button @click="closeModal" class="close-button">&times;</button>
                <p>{{ isotope.name }}</p>
                <p v-if="isotope.atomicNumber">{{ isotope.atomicNumber }}</p>
                <p v-if="isotope.atomicMass">{{ isotope.atomicMass }}</p>
              </div>
            </div>
            <div class="isotope-info" v-if="isotope.content">
              <p v-html="processedContent(isotope.content)"></p>
              <a class="cta cursor-pointer" @click="handleEnquireClick">Click here to enquire</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useNavigation } from '../composables/useNavigation.js';
import { processContent } from '../utils/markdown';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  isotope: {
    type: Object,
    default: null
  }
});

const emit = defineEmits(['close', 'enquire']);
const { goToPage } = useNavigation();
const closeModal = () => {
  emit('close');  
};

const handleEnquireClick = () => {
  // Emit enquire event with isotope information
  emit('enquire', {
    name: props.isotope?.name
  });
  closeModal();
};

const formatPropertyName = (key) => {
  return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
};

// Process second content area with markdown
const processedContent = (content) => {
  return content ? processContent(content) : '';
};


</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 20px;
  max-width: 450px;
  width: 90%;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.isotope-header {
  position: relative;
  flex: 1;
}

.isotope-header p {
  margin: 0 0 10px 0;
  color: #7f73e6;
}

.isotope-header p:first-of-type {
  font-size: 30px;
}

.close-button {
  position: absolute;
  top: -20px;
  right: -20px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #7f73e6;
  padding: 10px;
  border-radius: 50%;
  border: 2px solid #000;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-column {
  flex-direction: column;
  flex: 1;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 50px;
}

.isotope-details {
  display: flex;
  gap: 20px;
}

.isotope-symbol {
  font-size: 48px;
  font-weight: bold;
  background: #7f73e6;
  color: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  min-width: 100px;
  height: fit-content;
}

.isotope-info {
  width: 100%;
}

.isotope-info p {
  margin: 10px 0;
  line-height: 1.5;
  font-family: "BentonSans Book", sans-serif;
}

.properties {
  margin-top: 20px;
}

.properties h3 {
  margin-bottom: 10px;
  color: #333;
}

.properties ul {
  list-style: none;
  padding: 0;
}

.properties li {
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.properties li:last-child {
  border-bottom: none;
}

@media (max-width: 767px) {
  .isotope-details {
    flex-direction: column;
  }

  .isotope-symbol {
    align-self: center;
  }

  .close-button {
    top: -10px;
    right: -10px;
    width: 30px;
    height: 30px;
  }

  .modal-content {
    width: 100%;
  }

  .modal-body {
    padding: 20px;
  }

  .isotope-symbol {
    font-size: 24px;
    padding: 10px;
    min-width: unset;
  }
}
</style>
